var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive && _vm.countdown !== 'Started')?_c('v-alert',{attrs:{"type":"info"}},[_c('p',[_vm._v("Stream starts in: "+_vm._s(_vm.countdown))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }